import { render, staticRenderFns } from "./waterfall-item.vue?vue&type=template&id=e036f2d2"
import script from "./waterfall-item.vue?vue&type=script&lang=js"
export * from "./waterfall-item.vue?vue&type=script&lang=js"
import style0 from "./waterfall-item.vue?vue&type=style&index=0&id=e036f2d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports